<template>
  <ExpandCard
    ref="history_expand_card"
    storeKey="expandcard_history"
    persistKey="card-trainer-history"
    :closed="closed"
    :canClose="canClose"
    :icon="'mdi-history'"
    :title="$t('practice.history.title')"
    :closedTooltip="$t('practice.history.title')"
    style="
      --max-height: var(--max-height-history);
      --content-padding: 0 0.25rem;
      --content-padding: 0;
      --tooltip-margin: -2rem 0 0 -1rem;
      --tooltip-transform: translate(-100%, 0);
      --radius-open: 4px;
    "
    tour="tra_live_history"
    @update:open="open => $emit('update:open', open)"
  >
    <div class="trainer-history-replay trahisrepl"></div>
    <div
      v-if="l_items.length"
      class="trainer-history trahis"
    >
      <VirtualList
        ref="scroller"
        :hasDynamicSize="true"
        :items="l_items"
        idKey="uid"
        :estimateSize="56"
        :keeps="50"
        class="trahis_scroller no-scroll-track"
      >
        <template #item="{ item, index }">
          <TrainerHistorySessionItem
            v-if="item.session_state"
            :item="item"
            @click="setSessionStats(item)"
          />
          <div
            v-else
            class="trahis_item"
          >
            <TrainerHistoryItem
              :expanded="openHandsUid.includes(item.uid)"
              :active="activeHandsUids.includes(item.uid)"
              :replayedSpotId="
                panelReplayOpen && replayHandUid === item.uid ? replayedSpot.id : null
              "
              :item="item"
              :showBetsIn="showBetsIn"
              :showEvIn="showEvIn"
              @update:open="toggleHandsExpanded(item)"
              @click:replay="unstrigifiedItem => openInReplayer(unstrigifiedItem)"
            />
          </div>
        </template>
      </VirtualList>
    </div>
    <div
      v-else
      class="f-center f-column pa-4"
    >
      <i
        class="mdi mdi-history opacity_1"
        style="font-size: 4.5rem"
      />
    </div>
  </ExpandCard>
</template>

<script>
import { nextTick } from 'vue'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import TrainerHistoryItem from '@/components/Trainer/TrainerHistoryItem'
import TrainerHistorySessionItem from '@/components/Trainer/TrainerHistorySessionItem'
import VirtualList from '@/components/vue3/VirtualList/VirtualList'
import findLast from 'lodash/findLast'

export default {
  name: 'TrainerHistory',
  components: {
    TrainerHistoryItem,
    TrainerHistorySessionItem,
    VirtualList,
    ExpandCard,
  },
  props: {
    closed: Boolean,
    panelReplayOpen: Boolean,
    canClose: { type: Boolean, default: true },
  },
  emits: ['update:open'],
  data() {
    return {
      openHandsUid: [],
    }
  },
  methods: {
    expandHand(hand) {
      this.openHandsUid = [hand.uid]
      const idx = this.l_items.findIndex(i => i.uid === hand.uid)
      if (idx !== -1) {
        nextTick(() => {
          this.$refs.scroller.scrollToIndex(idx)
        })
      }
    },
    toggleHandsExpanded(hand) {
      if (this.openHandsUid.includes(hand.uid)) {
        this.openHandsUid = this.openHandsUid.filter(idx => idx !== hand.uid)
        return
      }
      this.openHandsUid = [...this.openHandsUid, hand.uid]
    },
    setSessionStats(session) {
      this.$store.dispatch(`stats_show_session_result`, session)
    },
    openInReplayer(hand, keepReplayOpen = false) {
      this.applyState(hand, keepReplayOpen)
      this.expandHand(hand)
    },
    applyState(hand, keepReplayOpen = false) {
      this.$store.commit(`stats_set`, { key: 'stats_session_result_visible', value: false })

      let { uid, session_uid, history_spots, query_trainer_history, trainer_state } = hand

      const replayHandUid = this.$store.getters[`tra/replay/trainer_hand_uid`]
      // debugger
      if (replayHandUid === uid && this.$store.getters.panel_replay) {
        if (!keepReplayOpen) {
          this.$store.commit(`panels_set`, { key: 'panel_replay', value: false })
        }
        return
      }

      const namespace = this.mobile ? 'tra/alpha' : 'tra/replay'
      // const namespace = 'tra/replay'
      this.$store.dispatch(`hands_set_active_namespace`, { namespace })

      this.$store.dispatch('poker_trainer_api_reset', { namespace })

      this.$store.dispatch(`${namespace}/trainer_auto_new_hand_stop`)
      this.$store.dispatch(`${namespace}/trainer_clear_timebank`)
      this.$store.dispatch(`${namespace}/anim_player_reset`)
      this.$store.commit(`${namespace}/trainer_reset`, trainer_state)

      const hSpots = history_spots
      // let hSpots = JSON.parse(history_spots)

      this.$store.commit(`${namespace}/gamestate_set`, {
        key: 'history_spots',
        value: hSpots,
      })

      const lastHeroSpot = findLast(hSpots, spot => spot?.type === 'player' && !spot?.is_bot)
      if (lastHeroSpot) {
        this.$store.commit(`${namespace}/trainer_set`, {
          key: 'trainer_overview_spot',
          value: lastHeroSpot,
        })
      }
      // console.log(query_trainer_history)

      const session = (this.sessions || []).find(s => s.uid === session_uid)
      const session_settings = session?.session_state?.session_settings || {}

      query_trainer_history = {
        ...session_settings,
        ...query_trainer_history,
        fh_trainer_tables: '',
        fh_trainer_session: '',
      }
      this.$store.dispatch(`${namespace}/trainer_router_update_query`, {
        query: query_trainer_history,
        push: false,
      })

      this.$store.commit(`${namespace}/trainer_set`, {
        key: 'trainer_quick_result_visible',
        value: false,
      })
      this.$store.commit(`${namespace}/trainer_set`, { key: 'trainer_result_visible', value: true })
      this.$store.commit(`${namespace}/trainer_set`, { key: 'trainer_hand_finished', value: true })

      if (this.mobile) {
        this.$store.commit(`panels_set`, { key: 'panel_right', value: false })
        return
      }
      this.$store.commit(`panels_set`, { key: 'panel_replay', value: true })
    },
    scrollToTop() {
      if (this.$refs.scroller) {
        this.$refs.scroller.$el.scrollTop = 0
      }
    },
  },
  computed: {
    l_items() {
      let res = [...this.$store.getters.history_hands, ...this.$store.getters.history_sessions]
      res = res.sort((a, b) => (a.created_at > b.created_at ? -1 : 1))
      return res
    },
    activeHandsUids() {
      return this.$store.getters.hands_active_uids
    },
    historyItemUid() {
      return this.$store.getters.trainer_history_uid
    },
    sessionItemUid() {
      return this.$store.getters.trainer_session_uid
    },
    replayHandUid() {
      return this.$store.getters[`tra/replay/trainer_hand_uid`]
    },
    replayedSpot() {
      return this.$store.getters[`tra/replay/history_spot`]
    },

    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
  watch: {
    l_items() {
      this.scrollToTop()
    },
  },
}
</script>
<style lang="scss">
.trahis_scroller {
  height: 100%;
  min-width: 12rem;
  max-height: var(--vh-7-5);
  max-height: var(--max-height-history);
}
// TODO that magic scroll thumb
</style>

<style lang="scss" scoped>
.trahis {
  background: var(--clr-black-1);
  flex: 1;
  position: relative;
  max-height: var(--vh-7-5);
  max-height: var(--max-height-history);
  &_item {
    border-bottom: 0.25rem solid transparent;
  }
}

.trahisrepl {
  position: absolute;
  left: 0;
  transform: translate(-100%, 0);
  background: var(--clr-black-1);
  height: 100%;
  padding: 1rem;
}
</style>
